var scope_0 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/190242104f89d4e0f11f38ed1753dbbe.js').default;
var scope_1 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4fa98c70b2c8c82cc80a29388518c7ca.js').default;
var scope_2 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5c177f2a30c5217cdbbebbe3510500a5.js').default;
var scope_3 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/73dc5522dc6c69de7bebaf7f3d3afee4.js').default;
var scope_4 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/91e6ad4d8e567934d609cf113ea3e4cf.js').default;
var scope_5 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99c470974837e95d8eae235f608ea536.js').default;
var scope_6 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a2b5d60038941ef1d0ab1eae75e7498c.js').default;
var scope_7 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6e039a55560b9f5886a946c040ce9bc.js').default;
var scope_8 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cc657097de7708deaa76d1724b54770a.js').default;
var scope_9 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d776b1652d6e0150c5b0ea1215a3ab27.js').default;
var scope_10 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_11 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ebe5ea7999c989f32f62c6547578c184.js').default;
var scope_12 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f6412223c182e72320e7cee7816d70aa.js').default;
var scope_13 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f8af66e72014436eaec6f7c2434d5e60.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    